module.exports = {
	SCREEN_WIDTH:256,
	SCREEN_HEIGHT:240,
	controller:{
		up:"P1Up",
		down:"P1Down",
		left:"P1Left",
		right:"P1Right",
		
		start:"P1Start",
		select:"P1Select",
		
		a:"P1A",
		b:"P1B"
	},
	controllerP2:{
		up:"P2Up",
		down:"P2Down",
		left:"P2Left",
		right:"P2Right",
		
		start:"P2Start",
		select:"P2Select",
		
		a:"P2A",
		b:"P2B"
	}
};